import check from "../images/check-circle.svg";
export const getTitleParaFun = (step) => {
   switch (step) {
      case 1:
         return { title: "Simplified charting. Amplified free time." };
      case 2:
         return {
            title: "Chart smarter, not harder",
            para: "Clinical conversations to complete documentation in seconds with Playback Pro",
         };
      case 3:
         return {
            title: "Don’t go back to documentation drudgery",
            para: "You’ve experienced the difference! Now keep it going. With Playback Pro, you get:",
         };
      default:
         return;
   }
};

export const checkBoxData = [
   { id: 1, img: check, text: "Intelligent transcription for hands-free note-taking" },
   { id: 2, img: check, text: "Lightning-fast editing, translation, and sharing capabilities" },
   { id: 3, img: check, text: "Secure, HIPAA-compliant data management" },
   { id: 4, img: check, text: "Seamless integration with leading EMR platforms" },
];

export const buttonText = (num) => {
   const texts = {
      1: "Start 14-day Free Trial",
      2: "Continue to Payment",
      3: "I need more time",
      4: "Contact Sales for Custom Solutions",
      5: "Done",
      6: "Continue with Playback Pro",
   };

   return texts[num] || "Start Subscription";
};
